<template>
  <section id="job" class="py-24 bg-light-gray">
    <div class="container mx-auto px-6 md:px-14 md:py-14">
      <div class="text-center mb-16 reveal">
        <div class="accent-line mx-auto w-24 mb-4" />
        <h2 class="text-3xl md:text-4xl font-display font-bold mb-4 text-dark-text">
          <span class="text-gradient bg-gradient-to-r from-primary to-secondary">
            加入我们
          </span>
        </h2>
        <p class="text-gray-600 max-w-2xl mx-auto">与一群热爱游戏的人一起工作，创造令人惊叹的游戏体验，实现自己的游戏梦想</p>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12 reveal">
        <div v-for="(job, index) in jobCategories" :key="index" class="bg-gradient-to-r from-tab_primary/5 to-tab_secondary/5 p-8 rounded-xl transition-all duration-300 hover:border-primary/50 hover:shadow-lg">
          <router-link :to="url">
            <div class="w-14 h-14 rounded-lg flex items-center justify-center mb-6" :class="(index % 2 === 0) ? 'bg-tab_primary/5':'bg-tab_secondary/5'">
              <i :class="job.icon"></i>
            </div>
            <h3 class="text-black text-xl font-bold mb-3">{{ job.title }}</h3>
            <p class="text-gray-400 mb-4">{{ job.content }}</p>
            <a href="#" class="text-secondary hover:text-white transition-colors inline-flex items-center gap-1">
              {{ "查看职位" }}<i class="fa fa-chevron-right"></i>
            </a>
          </router-link>
        </div>
      </div>

      <div class="bg-gradient-to-r from-tab_primary/5 to-tab_secondary/5 rounded-2xl p-8 md:p-12 relative overflow-hidden hover:border-primary/50 hover:shadow-lg reveal">
        <div class="absolute top-0 left-0 w-full h-full bg-grid opacity-20"></div>
        <router-link :to="url" class="relative z-10 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 class="text-black text-2xl md:text-3xl font-bold mb-4">准备好加入我们了吗？</h3>
            <p class="text-black mb-6">我们提供有竞争力的薪酬福利、良好的工作环境和成长空间，期待你的加入。</p>
            <a href="#" class="inline-flex items-center gap-2 bg-white gradient-border gradient-flow hover:opacity-90 text-dark px-8 py-3 rounded-full font-medium transition-all duration-300 hover:shadow-lg">
              {{ "查看职位详情" }}<i class="fa fa-chevron-right"></i>
            </a>
          </div>
          <div class="text-black flex flex-wrap gap-4">
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-users text-tab_primary mr-2"></i>
              <span>团队活动</span>
            </div>
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-sitemap text-tab_secondary mr-2"></i>
              <span>团队建设</span>
            </div>
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-birthday-cake text-tab_primary mr-2"></i>
              <span>周年庆</span>
            </div>
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-plane text-tab_secondary mr-2"></i>
              <span>年度旅游</span>
            </div>
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-coffee text-tab_primary mr-2"></i>
              <span>定期下午茶</span>
            </div>
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-cutlery text-tab_secondary mr-2"></i>
              <span>年度聚餐</span>
            </div>
            <div class="bg-dark/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i class="fa fa-money text-tab_primary mr-2"></i>
              <span>公积金</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { get_head_data } from '@/api'
import vv from '@/components/varVariable.vue'

export default {
  name: 'Job',
  data() {
    return {
      jobCategories: [
        {
          title: '游戏开发',
          icon: 'fa fa-code text-tab_primary text-2xl',
          content: '负责游戏核心系统、玩法机制的设计与实现，打造流畅的游戏体验。'
        },
        {
          title: '游戏美术',
          icon: 'fa fa-paint-brush text-tab_secondary text-2xl',
          content: '负责角色、场景、道具等游戏视觉元素的设计与制作，塑造独特的游戏风格。'
        },
        {
          title: '游戏策划',
          icon: 'fa fa-pencil text-tab_primary text-2xl',
          content: '负责游戏世界观、剧情、玩法的设计，构建引人入胜的游戏体验。'
        },
        {
          title: '运维工程师',
          icon: 'fa fa-server text-tab_secondary text-2xl',
          content: '负责游戏服务器架构设计与维护，保障游戏服务稳定运行与玩家体验。'
        }
      ],
      url: ''
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    get_head_data().then(d => {
      this.url = d.heads[2].u
    })
  }
}
</script>
